<template>
  <Loader :loader="loaderActive"/>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="tournament-back d-flex justify-content-start align-items-center">
          <a class="tournament-back-link cursor-pointer" @click="$router.back()">←</a>
          <div class="tournament-page-title">
            টুর্নামেন্ট বান্ডেল
          </div>
        </div>
      </div>
    </div>

    <div class="tournament-bundle-header">
      <div class="row">
        <div class="col-lg-3" v-for="tournament_pack in tournamentPacks" :key="tournament_pack.bundle_id">
          <div class="tournament-bundle-card d-flex flex-column justify-content-start">
            <div class="pack-title">
              {{ tournament_pack.title }}
            </div>
            <div class="pack-subtitle">
              {{ tournament_pack.caption }}
            </div>
            <div class="pack-amount-details d-flex justify-content-between align-items-center">
              <div class="amount">{{ tournament_pack.price }} টাকা</div>
              <div class="pack-subscribe" v-if="! tournament_pack.is_subscribed"
                   @click="getPayment(tournament_pack.bundle_id, 'bundle', false)">সাবস্ক্রাইব করুন</div>
              <div class="pack-subscribe" @click="cancelSubscription(tournament_pack.bundle_id)" v-else>বাতিল করুন</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {sendRequest} from "@/http/axios.method";
import Loader from "@/views/components/Loader";

export default {
  name: "TournamentBundle",
  components: {
    Loader
  },
  data() {
    return {
      loaderActive: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      tournamentPacks: [],
    }
  },
  created() {
    this.getTournamentPack();
  },
  methods: {
    getTournamentPack() {
      this.loaderActive = true;
      sendRequest('get', 'v2.0/tournament-packs', {}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.tournamentPacks = response.data.packages;
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    cancelSubscription(bundle_id) {
      sendRequest('post', 'v2.0/ghoori-subscription-cancel', {bundle_id: bundle_id}, this.config)
          .then(() => {
            this.loaderActive = false;
            this.getTournamentPack();
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    getPayment(payment_id, payment_type, is_on_demand) {
      this.$router.push({
        path: '/payment-method',
        query: {payment_id: payment_id, type: payment_type, is_on_demand: is_on_demand}
      });
    }
  }
}
</script>

<style scoped>

</style>
